import { render, staticRenderFns } from "./TruncateText.vue?vue&type=template&id=12084288"
import script from "./TruncateText.vue?vue&type=script&lang=js"
export * from "./TruncateText.vue?vue&type=script&lang=js"
import style0 from "./TruncateText.vue?vue&type=style&index=0&id=12084288&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports